<ng-container *ngIf="materialUpdate$ | async"></ng-container>

<div class="flex flex-col items-center gap-4">
  <div class="mat-title w-full" i18n>Текстура</div>

  <div class="texture-map flex flex-wrap">
    <ng-container *ngTemplateOutlet="edgeTmpl; context: { $implicit: panel?.l1, classes: 'horizontal', side: 'tc' }">
    </ng-container>
    <ng-container *ngTemplateOutlet="edgeTmpl; context: { $implicit: panel?.w1, classes: 'vertical', side: 'lc' }">
    </ng-container>

    <ng-container *ngIf="showColorMaterial(); then showColor; else showTexture"></ng-container>

    <ng-template #showColor>
      <div class="main color" [ngStyle]="getColorMaterial()"></div>
    </ng-template>
    <ng-template #showTexture>
      <img
        class="main"
        [ngClass]="getTextureDirection()"
        draggable="false"
        [src]="getPathToTexture(upperMaterial) || 'assets/images/no-texture.svg'"
        [defaultImg]="'assets/images/default-texture.svg'" />
    </ng-template>

    <ng-container *ngTemplateOutlet="edgeTmpl; context: { $implicit: panel?.w2, classes: 'vertical', side: 'rc' }">
    </ng-container>
    <ng-container *ngTemplateOutlet="edgeTmpl; context: { $implicit: panel?.l2, classes: 'horizontal', side: 'bc' }">
    </ng-container>
  </div>

  <ng-template #edgeTmpl let-edge let-classes="classes" let-side="side">
    <div class="edge-wrapper {{ classes }}">
      <div class="actions" (click)="toggleEdge(!edge, side)" *ngIf="outerMaterial && !disabled">
        <mat-icon class="fuse-white-fg s-18">{{ edge ? 'close' : 'add' }}</mat-icon>
      </div>

      <ng-container *ngIf="!outerMaterial?.textureName && outerMaterial?.color; then showColor; else showTexture">
      </ng-container>

      <ng-template #showColor>
        <div
          [attr.class]="'edge color rotate-' + (outerMaterial?.textureRotationDegree | json) + 'deg ' + side"
          [style.--edge-texture]="'#' + outerMaterial?.color"></div>
      </ng-template>

      <ng-template #showTexture>
        <div
          [attr.class]="'edge rotate-' + (outerMaterial?.textureRotationDegree | json) + 'deg ' + side"
          [style.--edge-texture]="
            'url(' +
            ((getPathToTexture(isFilm() ? outerMaterial : edge) | json) || '/assets/images/no-texture.svg') +
            ')'
          "></div>
      </ng-template>
    </div>
  </ng-template>

  <mat-button-toggle-group
    [disabled]="disabled"
    *ngIf="!this.panel?.material?.film"
    [value]="panel.textureDirection"
    (change)="changeDirection($event.value)">
    <mat-button-toggle [value]="0" i18n>По вертикали</mat-button-toggle>
    <mat-button-toggle data-testid="horizontalTexture" [value]="1" i18n>По горизонтали</mat-button-toggle>
  </mat-button-toggle-group>
</div>
